/**
 * @file clientNotificationTemplateService.js
 * @description Client-safe notification template requests for the
 * client Notifications > Templates tab.
 *
 * These endpoints return only templates that are available to the
 * current client (active + agency/global + tier-matched).
 */

import { clientApiHttp } from './httpService';

const getTenantId = () => +window.localStorage.getItem('tenantId');
const resolveTenantId = tenantId => tenantId || getTenantId();

const basePath = tenantId =>
    `/v2/client/${resolveTenantId(tenantId)}/notification/templates`;

/**
 * Fetch all notification templates available to the current client.
 * This endpoint is already filtered server-side.
 */
export const getClientNotificationTemplates = async tenantId => {
    try {
        const response = await clientApiHttp.get(basePath(tenantId));
        return response.data;
    } catch (error) {
        console.error('Error fetching client notification templates:', error);
        throw error;
    }
};

/**
 * Fetch a single notification template available to the current client.
 * This endpoint is already filtered server-side.
 */
export const getClientNotificationTemplateById = async (
    tenantId,
    notificationTemplateId,
) => {
    try {
        const response = await clientApiHttp.get(
            `${basePath(tenantId)}/${notificationTemplateId}`,
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching client notification template:', error);
        throw error;
    }
};
